document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".swiper-testimonial", {
    slidesPerView: 1.3,
    spaceBetween: 12,
    slideToClickedSlide: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true, 
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
      500: {
        slidesPerView: 2,
        spaceBetween: 28,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
    },
  });
});

